<template>
    <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMainServer
          :datatable="table"
          :on-success="SuccessTableAction"
          :itemsAction="SuccessTableAction"
          :Updatepagination="params"
          :on-pagination="pagePagination"
          :on-search="getSearchPagePagination"
        />
        <ViewDetails :object="object" type="JugadoresDetails" />
      </v-col>
    </v-row>
    <v-dialog v-model="showPDFModal" max-width="70%">
      <v-card>
        <v-card-title class="headline">Documento PDF</v-card-title>
        <v-card-text>
          <!-- Mostrar el PDF en un iframe -->
          <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="430px"></iframe>
          <p v-else>No se pudo cargar el PDF.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="showPDFModal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
    <v-col cols="4" class="d-flex justify-end ml-auto pa-4 ma-0 mt-0 pt-0" style="border: 1px solid white; padding: 0; margin: 0;">
      <v-switch
        v-model="showDisabled"
        :label="showDisabled ? 'Mostrando desactivados' : 'Ocultando desactivados'"
        inset
        @change="refreshData"
        hide-details
      ></v-switch>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import axios from 'axios'
import * as XLSX from 'xlsx'

export default {
  mixins: [Permission],
  props: {
    liga: {
      type: Object,
      required: true
    },
    equipos: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    openDialog: false,
    showPDFModal: false,
    showDisabled: false,
    pdfUrl: '',
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'equipo.entry' },
          { title: 'Conf. Equipos', icon: 'mdi-cog', color: 'orange', action: 'maxEquipo', code: 'equipos.maxteam' },
          { title: 'Conf. Jugadores', icon: 'mdi-cog', color: 'orange', action: 'maxPlayer', code: 'jugadores.maxplayer' },
          { title: 'Excel Jug.', icon: 'mdi-file-excel', color: 'success', action: 'ExcelData', code: 'empresa.empleados.excel' }
          // { title: 'Desactivados/Activos', icon: 'mdi-eye-off', color: 'red', action: 'viewDisabled', code: 'equipo.refresh' }
        ],
        titles: [
          { text: 'Equipo', value: 'nombre', class: 'black--text' },
          { text: 'Responsable', value: 'descripcion.responsable.NombreCompleto', class: 'black--text' },
          { text: 'Telefono', value: 'descripcion.responsable.caracteristicas.telefono', class: 'black--text' },
          { text: 'Inscritos', value: 'NumJugadores', class: 'black--text' },
          { text: 'activo', value: 'activo', class: 'black--text' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          // { title: 'Ver Jugadores', icon: 'mdi-soccer', color: 'blue', action: 'toJugadores', code: '' },
          { title: 'Crear Jugador', icon: 'mdi-plus', color: 'success', action: 'newJugador', code: 'create.jugador' },
          { title: 'Importar Jugadores', icon: 'mdi-upload', color: 'info', action: 'importData', code: 'import.jugadores' },
          { title: 'Añadir Jugador', icon: 'mdi-account-check', color: 'blue', action: 'newPlayer', code: 'Agregar.Jugador' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'toUpdate', code: 'equipo.edit' },
          { title: 'invalidar Documentos', icon: 'mdi-cancel', color: 'red', action: 'invalidateDocuments', code: 'document.invalidate' },
          { title: 'Doc. Responsable', icon: 'mdi-file-document', color: 'blue', action: 'toDocument', code: 'document.responsable' },
          { title: 'Cred. Responsable', icon: 'mdi-card-account-details', color: 'blue', action: 'mostrarDoc', code: 'cred.responsable' },
          { title: 'Desactivar/Activar', icon: 'mdi-contrast-circle', color: 'grey darken-3', action: 'disableData', code: 'disable.equipo' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {},
    breadcrumb: [] // Inicializa el breadcrumb
  }),
  components: {
    DataTableMainServer,
    ViewDetails
  },
  mounted () {
    // console.log('Equipos en el componente hijo:', this.equipos)
    // console.log('Liga prop:', this.liga)
    // Obtener el breadcrumb de la ruta
    this.breadcrumb = this.$route.meta.breadcrumb || []

    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES', 'SHOW_DIALOG_REPORT', 'SHOW_DIALOG_ALERT_MAIN']),
    SuccessTableAction (item) {
      this[item.action](item)
    },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    // *==========*==========*==========*    Methods Table Pagination    *==========*==========*==========* \\
    pagePagination (val) {
      this.table.header.loading = true // Muestra el estado de carga
      if (val) this.params = val // Actualiza params si se pasa un valor
      else this.params = this.default // Usa valores por defecto si no
      // Verifica que el espacio esté definido antes de usarlo
      if (!this.liga) {
        console.error('El ID del espacio no está definido.')
        return // Sale si el ID del espacio no está disponible
      }
      // Asigna el espacioId usando el valor recibido como prop
      this.params.ligasId = this.liga
      // Ejecuta la URL para obtener la paginación
      this.ExecuteUrl('equipos.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('equipos.list-pagination')
    },
    // *==========*==========*==========*==========*==========*==========*==========*==========*==========* \\
    filterData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filter',
        with: '60%',
        title: 'FILTRAR',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_InventariosEquiposFilterForm,
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    toJugadores (item) {
      const EquiposId = { id: item.item.id, nombre: item.item.descripcion } // Asegúrate de que este sea el campo correcto para el ID del espacio
      this.$emit('viewJugadores', EquiposId)
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      console.log('Liga', this.liga.id)
      console.log('Torneo', this.liga.torneo)
      this.table.header.loading = true
      this.params.showDisabled = this.showDisabled
      // Asegúrate de que tienes el valor de ligasid antes de pasarlo
      const ligasid = this.liga ? this.liga.id : null
      const Torneo = this.liga ? this.liga.torneo : null
      // console.log('Liga ID:', ligasid)
      // console.log('torneo', Torneo)

      // Actualiza los parámetros con ligasid
      if (ligasid) {
        this.params.ligasId = ligasid
      } else {
        console.error('Liga ID no definido.')
        return
      }
      this.params.torneo = Torneo || null

      // Ejecutar la URL para obtener los datos con el parámetro ligasid
      this.ExecuteUrl('equipos.list-pagination')
    },
    viewDisabled () {
      this.showDisabled = !this.showDisabled // Cambia el estado
      this.refreshData() // Actualiza los datos mostrados
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Equipo`,
        body: {
          objectMain: item,
          url: this.get_urls['equipos.desactive'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    newData (item) {
      // console.log('¿Se alcanzó el límite de equipos?', this.maxTeamReached) // Revisa si maxTeamReached está funcionando correctamente
      if (this.maxTeamReached) {
        this.$swal.fire({
          type: 'error',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'Se Alcanzo el Limite De Equipos.'
        })
        return
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nuevo Equipo',
        body: {
          objectMain: { tipo_actividad_id: 4, empresa_id: this.user.empresa_id, ligasid: this.liga.id, user: this.user.usuario_id },
          paramsDialog: {
            url: this.get_urls['equipos.execute'],
            urloption: this.get_urls['equipos.options'],
            process: 4,
            actividad: 4,
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    ExcelData () {
      // Definir los encabezados personalizados
      const headers = [
        'nombres',
        'apellidos',
        'telefono',
        'rfc',
        'fecha_nacimiento',
        'curp',
        'calle',
        'numero',
        'cruzamiento 1',
        'cruzamiento 2',
        'codigo postal'
      ]

      // Crear una hoja de cálculo con los encabezados y sin datos
      const ws = XLSX.utils.aoa_to_sheet([headers])

      // Crear un nuevo libro de Excel y agregar la hoja
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Integrantes')

      // Generar y descargar el archivo Excel
      XLSX.writeFile(wb, 'Integrantes.xlsx')
    },
    importData (item) {
      console.log('data', this.liga.nombre.maxplayer)
      const data = {
        empleado_id: this.user.empleado_id,
        equipo_id: item.item.descripcion.equipo_id,
        maxplayer: this.liga.nombre.maxplayer
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Importar Integrantes',
        body: {
          objectMain: { data },
          paramsDialog: {
            url: this.get_urls['empresa.empleados.execute'],
            urloption: this.get_urls['empresa.empleados.options'],
            message: 'Registro Agregado Correctamente',
            formdata: true,
            updated: true,
            returnObject: true,
            setmodel: true
            // onSuccess: () => {
            //   this.refreshData() // Refrescar tabla después de la importación
            // }
          },
          method: 'form-data'
        }
      })
    },
    mostrarDoc: function (item) {
      console.log('item', item.item)
      this.progressbar = true
      const token = this.$cookies.get('token')
      const header = { Authorization: `Bearer ${token}` }
      const formData = new FormData()
      const integrantes = [
        {
          id: item.item.descripcion.responsable.id,
          rol: 'Encargado'
        }
      ]
      const equipoData = {
        equipo_id: item.item.id,
        nombre: item.item.nombre,
        padre_id: item.item.padre_id,
        tipo: 'Encargado',
        integrantes: integrantes
      }
      formData.append('documento', JSON.stringify(this.documento))
      formData.append('model', JSON.stringify(equipoData))
      axios.post('/empresa/documentos/credencial', formData, { headers: header })
        .then((response) => {
          console.log('Respuesta de la API:', response.data)

          let blob = null
          const fileType = response.data.type

          if (fileType.startsWith('image/')) {
            // Procesar imagen
            const byteCharacters = atob(response.data.file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], { type: fileType })
          } else if (fileType === 'application/pdf') {
            // Procesar PDF
            const byteCharacters = atob(response.data.file)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], { type: 'application/pdf' })
          } else {
            console.error('El archivo recibido no es una imagen ni un PDF.')
            this.progressbar = false
            return
          }

          this.pdfUrl = URL.createObjectURL(blob)
          console.log('URL del archivo generado:', this.pdfUrl)

          this.progressbar = false
          this.showPDFModal = true
        })
        .catch((error) => {
          console.error('Error al mostrar documento:', error)
          this.progressbar = false
        })
    },
    toDocument (item) {
      console.log('item:', item)
      this.SHOW_DIALOG_MAIN({
        type: 'charge',
        form: 'process',
        with: '50%',
        title: 'Documentacion',
        body: {
          objectMain: { num: 1, item: item.item.descripcion.responsable, slug: 'int' },
          paramsDialog: {
            url: this.get_urls['documentos.execute'],
            urloption: this.get_urls['documentos.options'],
            setmodel: true,
            data: item.item
          }
        }
      })
    },
    newJugador (item) {
      const data = {
        empleado_id: this.user.empleado_id,
        item: item
      }
      console.log('item', this.user)
      const tituloDialogo = `Nuevo Jugador Para ${item.item.nombre || 'desconocido'}`
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 850,
        title: tituloDialogo,
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create'],
            message: 'Registro Agregado Correctamente',
            updated: true,
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    toUpdate (item) {
      console.log('Datos antes:', item)
      const jugador = item.item.descripcion.integrantes
      console.log('integrantes:', jugador)
      const data = {
        id: item.item.id,
        torneo_id: item.item.descripcion.torneo_id || null,
        user: this.user.usuario_id,
        ligasid: this.liga.id,
        equipo: item.item.nombre,
        integrantes: jugador,
        tipo_actividad_id: item.item.descripcion.tipo_actividad_id,
        empresa_id: item.item.empresa_id,
        responsable: item.item.descripcion.responsable.id || '', // ID del responsable seleccionado
        responsableEq: { // Objeto para inicializar el campo (opcional si el componente lo requiere)
          id: item.item.descripcion.responsable.id || '',
          NombreCompleto: item.item.descripcion.responsable.NombreCompleto || '' // Nombre visible del responsable
        }

      }
      console.log('Datos a enviar para actualización:', data)
      const tituloDialogo = `Editar Equipo ${item.item.nombre || 'desconocido'}`
      this.SHOW_DIALOG_MAIN({
        type: 'update',
        form: 'process',
        with: '60%',
        title: tituloDialogo,
        body: {
          objectMain: data,
          paramsDialog: {
            urloption: this.get_urls['equipos.options'],
            url: this.get_urls['equipos.execute'],
            process: 1,
            message: 'Registro Actualizado Correctamente',
            updated: true,
            setmodel: true
          }
        }
      })
    },
    newPlayer (item) {
      console.log('item de new player', item)
      // console.log('Datos antes player:', item.item.descripcion.responsable.uuaa_id)
      // console.log('¿Se alcanzó el límite de Jugadores', this.maxPlayerReached) // Revisa si maxTeamReached está funcionando correctamente
      if (this.maxPlayerReached(item)) {
        this.$swal.fire({
          type: 'error',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'Se Alcanzo el Limite De Jugadores.'
        })
        return
      }
      const tituloDialogo = `Agregar Jugador A ${item.item.nombre || 'desconocido'}`
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '50%',
        title: tituloDialogo,
        body: {
          objectMain: { id: item.item.id, tipo_actividad_id: item.item.descripcion.tipo_actividad_id, ua: item.item.descripcion.responsable.uuaa_id, numJugadores: item.item.NumJugadores },
          paramsDialog: {
            form: this.get_JugadoresForm,
            url: this.get_urls['jugadores.equipo'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    maxEquipo (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Maximo de Equipos',
        body: {
          objectMain: { ligasid: this.liga.id },
          paramsDialog: {
            form: this.get_TeamsForm,
            url: this.get_urls['equipos.maxteam'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    maxPlayer (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Maximo de Jugadores',
        body: {
          objectMain: { ligasid: this.liga.id },
          paramsDialog: {
            form: this.get_PlayersForm,
            url: this.get_urls['jugadores.maxplayer'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    invalidateDocuments (item) {
      console.log('item', item)
      const data = {
        jugadorIds: item.item.descripcion.integrantes
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '35%',
        title: `Invalidar Documentos de ${item.item.nombre}`,
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_InvalideForm,
            url: this.get_urls['empresa.documentos.validate'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    maxPlayerReached (item) {
      const maxPlayers = this.liga && this.liga.nombre && this.liga.nombre.maxplayer
        ? this.liga.nombre.maxplayer
        : null
      console.log('MaxPlayers:', maxPlayers)

      // Verifica si NumJugadores está disponible en el primer elemento de data
      const numJugadores = item.item.NumJugadores

      console.log('Current jugadores length:', numJugadores)
      // console.log('numJugadores:', numJugadores)
      // console.log('index', index)
      // Aplica la regla solo si maxPlayers tiene un valor, de lo contrario permite el paso
      return maxPlayers !== null ? numJugadores >= maxPlayers : false
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_objects', 'get_ImportForm', 'get_InventariosEquiposFilterForm', 'get_TeamsForm', 'get_JugadoresForm', 'get_PlayersForm', 'get_EmpleadoForm', 'get_InvalideForm']),
    object () {
      return this.table.modelMain.length > 0 ? this.table.modelMain[0] : {}
    },
    totalEquipos () {
      return this.table.body.data.length
    },
    maxTeamReached (data) {
      const maxTeams = this.liga && this.liga.nombre && this.liga.nombre.maxteam
        ? this.liga.nombre.maxteam
        : null
      console.log('MaxTeams:', maxTeams)
      console.log('Current equipos length:', data?.get_objectPagination?.data[0]?.Numequipos)
      return maxTeams !== null ? data?.get_objectPagination?.data[1]?.Numequipos >= maxTeams : false
    }
    // maxPlayerReached () {
    //   const maxPlayers = this.liga && this.liga.nombre && this.liga.nombre.maxplayer
    //     ? this.liga.nombre.maxplayer
    //     : null
    //   console.log('MaxPlayers:', maxPlayers)

    //   // Verifica si NumJugadores está disponible en el primer elemento de data
    //   const numJugadores = this.table.body

    //   console.log('Current jugadores length:', this.item)
    //   // console.log('numJugadores:', numJugadores)
    //   // console.log('index', index)
    //   // Aplica la regla solo si maxPlayers tiene un valor, de lo contrario permite el paso
    //   return maxPlayers !== null ? numJugadores >= maxPlayers : false
    // }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.table.body.totalData = rows.total
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') {
        this.refreshData({})
      }
      this.SEND_DATA_VIEW({})
    }
  }
}
</script>

<style scoped>
</style>
